import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../api/hooks/useAPI";
import ContainedButton from "../../../components/buttons/ContainedButton";
import { useOnboarding } from "../../../contexts/OnboardingContext";

const ConnectToolsStep = () => {
  const navigate = useNavigate();
  const { closeOnboardingModal } = useOnboarding();
  const { trackEvent } = useAPI();

  const handleConnectEDR = () => {
    trackEvent("User clicked connect EDR button");
    navigate("/inventory/integrations", {
      state: {
        filterIntegration: "EDR",
      },
    });
    closeOnboardingModal();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 3,
      }}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        Step 1 of 4
      </Typography>

      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3 }}>
        Connect Your First Tool
      </Typography>

      <Typography variant="body1" sx={{ mb: 3 }}>
        Start by connecting your <strong>EDR</strong>. This gives you immediate
        visibility into key exposures and active risks in your environment.
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        Click <strong>Connect</strong> to go to the integrations page. From
        there, choose your EDR and follow the short setup guide to complete the
        connection.
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ContainedButton
          color="primary"
          size="large"
          onClick={handleConnectEDR}
          fullWidth
        >
          Connect EDR
        </ContainedButton>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src="/onboarding/connect_tool.svg"
          alt="Connect tool"
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default ConnectToolsStep;
